import { useEffect, useState } from "react";
import { Wifi, WifiOff, RefreshCcw, CloudUpload } from "lucide-react";
import { onSyncChange, flushQueue, getStatus } from "@/lib/syncManager";

export default function OfflineIndicator() {
  const [state, setState] = useState({ online: true, count: 0, syncing: false });

  useEffect(() => {
    getStatus().then(setState);
    return onSyncChange(setState);
  }, []);

  // Hidden when fully online & nothing queued
  if (state.online && state.count === 0 && !state.syncing) return null;

  const tone = state.online
    ? state.syncing
      ? { bg: "rgba(34,211,238,0.12)", border: "var(--cyan)", color: "#67e8f9", label: "SINCRONIZANDO…" }
      : { bg: "rgba(244,114,182,0.12)", border: "var(--magenta)", color: "#f9a8d4", label: `${state.count} EN COLA` }
    : { bg: "rgba(220,38,38,0.12)", border: "#dc2626", color: "#fca5a5", label: "SIN CONEXIÓN" };

  const Icon = state.online ? (state.syncing ? RefreshCcw : CloudUpload) : WifiOff;

  return (
    <button
      data-testid="offline-indicator"
      onClick={() => state.online && flushQueue()}
      className="flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-[10px] font-semibold uppercase tracking-widest hover:bg-white/5 transition-colors"
      style={{ background: tone.bg, border: `1px solid ${tone.border}`, color: tone.color }}
      title={state.online ? "Sincronizar pendientes" : "Estás trabajando sin conexión. Tus registros se guardan localmente."}
    >
      <Icon className={`w-3.5 h-3.5 ${state.syncing ? "animate-spin" : ""}`} />
      <span>{tone.label}</span>
      {state.online && state.count > 0 && !state.syncing && (
        <span className="ml-1 px-1.5 rounded-sm font-mono" style={{ background: "rgba(0,0,0,0.3)" }}>{state.count}</span>
      )}
    </button>
  );
}
